import cx from 'classnames'
import type {
  CSSProperties,
  FC,
  HTMLAttributes,
  MouseEventHandler,
  ReactNode,
} from 'react'

import css from './DropDownList.module.scss'

export type DropdownItemProps = {
  active?: boolean
  disabled?: boolean
  badge?: ReactNode | null
  onBadgeClick?: () => void
  icon?: ReactNode
  text?: string
  shortcut?: string
  color?: 'dangerous'
} & HTMLAttributes<HTMLDivElement>

type Props = {
  children: (DropdownItemProps | null | (DropdownItemProps | null)[])[]
  onMouseDown?: MouseEventHandler<HTMLDivElement>
  size: 's' | 'm'
  hideShortcuts?: boolean
  className?: string
  itemClassName?: string
  style?: CSSProperties
}

const DropDownList: FC<Props> = ({
  children,
  onMouseDown,
  size,
  hideShortcuts,
  className,
  itemClassName,
  style,
}) => (
  <div
    style={style}
    onMouseDown={onMouseDown}
    className={cx(className, {
      [css.small]: size === 's',
      [css.medium]: size === 'm',
    })}
  >
    {children.filter(Boolean).map((itemPropsOrItemPropsList, i) => {
      const itemPropsList = Array.isArray(itemPropsOrItemPropsList)
        ? itemPropsOrItemPropsList
        : [itemPropsOrItemPropsList]

      return (
        <div className={css.vertSection} key={i}>
          {itemPropsList.filter(Boolean).map((itemProps, j) => {
            const {
              active,
              disabled,
              icon,
              badge,
              onBadgeClick,
              text,
              shortcut,
              className,
              color,
              ...htmlProps
            } = itemProps!

            const cNames = {
              item: cx(css.item, itemClassName, {
                [css.active]: active,
                [css.disabled]: disabled,
                [css.dangerous]: color === 'dangerous',
              }),
            }

            return (
              <div className={css.container} key={j}>
                <div {...htmlProps} className={cNames.item}>
                  <div className={css.iconContainer}>{icon}</div>
                  {text}
                  {shortcut && !hideShortcuts && (
                    <span className={css.shortcut}>{shortcut}</span>
                  )}
                </div>
                {badge && (
                  <div className={css.badgeWrapper} onClick={onBadgeClick}>
                    {badge}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )
    })}
  </div>
)

export default DropDownList
